import { updateObject } from 'utils/updateObject'
import setFilters from 'store/reducer-utils/setFilters'
import {
  ACCOUNT_LOAD_DATA_FAILED,
  ACCOUNT_TRANSFERS_CLEAN,
  ACCOUNT_TRANSFERS_FILTERS_APPLY,
  ACCOUNT_UPDATE_TRANSFERS,
  INIT_ACCOUNT,
  RESET_ACCOUNT_DATA,
  SET_ACCOUNT_DATA,
  SET_ACCOUNT_TRANSFERS_FILTERS,
  SET_ACCOUNT_TRANSFERS_QUERY,
  SET_TRANSFERS_DATA,
} from 'modules/Services/types'

const initialState = {
  loading: true,
  loaded: false,
  failed: false,
  type: null,
  networkId: null,
  login: '',
  accountId: null,
  balance: {
    amount: null,
    currency: null,
  },
  filters: null,
  transfers: {
    loading: true,
    loaded: false,
    data: [],
    summary: {},
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  },
}

const initAccount = (state, { payload }) => ({
  ...state,
  ...payload,
})

const setData = (state, { payload }) =>
  updateObject(state, { ...state, ...payload })

const applyFilters = (state, { payload }) =>
  updateObject(state, { filters: payload })

const setAccountTransfersQuery = (state, { payload }) =>
  setFilters(state, { payload })

const transfersClean = (state) =>
  updateObject(state, {
    transfers: {
      ...initialState.transfers,
    },
  })

const updateTransfers = (state, { payload }) =>
  updateObject(state, {
    transfers: {
      ...state.transfers,
      ...payload,
    },
  })

const setAccountTransfersFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const loadDataFailed = (state) => updateObject(state, { loading: false })

const setTransfersData = (state, { payload }) =>
  updateObject(state, {
    transfers: updateObject(state.transfers, { ...payload }),
  })

const dropAccountData = () => ({ ...initialState })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_ACCOUNT:
      return initAccount(state, action)
    case SET_ACCOUNT_DATA:
      return setData(state, action)
    case RESET_ACCOUNT_DATA:
      return dropAccountData(state)
    case ACCOUNT_TRANSFERS_CLEAN:
      return transfersClean(state)
    case ACCOUNT_UPDATE_TRANSFERS:
      return updateTransfers(state, action)
    case ACCOUNT_LOAD_DATA_FAILED:
      return loadDataFailed(state, action)
    case SET_TRANSFERS_DATA:
      return setTransfersData(state, action)
    case SET_ACCOUNT_TRANSFERS_QUERY:
      return setAccountTransfersQuery(state, action)
    case SET_ACCOUNT_TRANSFERS_FILTERS:
      return setAccountTransfersFilters(state, action)
    case ACCOUNT_TRANSFERS_FILTERS_APPLY:
      return applyFilters(state, action)
    default:
      return state
  }
}

export default reducer
